module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstates": _vm.appraisalreport_realestates,
        "realEstateId": _vm.realestate.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Edit_Real_Estate')) + " "), (_vm.realestate.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.realestate.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.realestate.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.realestate.property_type.name_es))])]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('at')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v(" " + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.realestate.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.realestate.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.realestate.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.realestate.date_modified)))])]), _vm._v(" "), _c('vue-tabs', {
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, [_c('v-tab', {
      attrs: {
        "title": _vm.identification_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Identificació i pre-taxació')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.identification_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Identification and pre-appraisal')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.identification_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Identificación y pre-tasación')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.identification_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_property_type
      },
      model: {
        value: (_vm.realestate.property_type),
        callback: function($$v) {
          _vm.realestate.property_type = $$v
        },
        expression: "realestate.property_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Asset_type')) + " (BdE)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.asset_typeValue,
        "options": _vm.asset_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_asset_type
      },
      model: {
        value: (_vm.realestate.asset_type),
        callback: function($$v) {
          _vm.realestate.asset_type = $$v
        },
        expression: "realestate.asset_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Dwelling_type')) + " (BdE)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.dwelling_typeValue,
        "options": _vm.dwelling_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_dwelling_type
      },
      model: {
        value: (_vm.realestate.dwelling_type),
        callback: function($$v) {
          _vm.realestate.dwelling_type = $$v
        },
        expression: "realestate.dwelling_type"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Country')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.countryValue,
        "options": _vm.countryOptions,
        "track-by": "iso_3166_alpha2_code",
        "label": 'name_en',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_country_option
      },
      model: {
        value: (_vm.realestate.country),
        callback: function($$v) {
          _vm.realestate.country = $$v
        },
        expression: "realestate.country"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.realestate.country) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.realestate.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.provinceValue,
        "options": _vm.spanishProvinceOptions,
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_province_option
      },
      model: {
        value: (_vm.realestate.province),
        callback: function($$v) {
          _vm.realestate.province = $$v
        },
        expression: "realestate.province"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.province),
        expression: "realestate.province"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.province)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.province = $event.target.value
        }, _vm.set_realestate_province]
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.realestate.province) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.realestate.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.municipalityValue,
        "options": _vm.object_to_array(_vm.realestate_municipalities),
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_municipality_option
      },
      model: {
        value: (_vm.realestate.municipality),
        callback: function($$v) {
          _vm.realestate.municipality = $$v
        },
        expression: "realestate.municipality"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.municipality),
        expression: "realestate.municipality"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.municipality)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.municipality = $event.target.value
        }, _vm.set_realestate_municipality]
      }
    })])]) : _vm._e()]), _vm._v(" "), (_vm.realestate.municipality) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.street_name),
        expression: "realestate.street_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.street_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.street_name = $event.target.value
        }, _vm.set_realestate_street_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.street_number),
        expression: "realestate.street_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "1",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.street_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.street_number = $event.target.value
        }, _vm.set_realestate_street_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.floor),
        expression: "realestate.floor"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.floor)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.floor = $event.target.value
        }, _vm.set_realestate_floor]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [(_vm.realestate.property_type.name_db === 'parking') ? _c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('pkg_number')))]) : _c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.door),
        expression: "realestate.door"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.door)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.door = $event.target.value
        }, _vm.set_realestate_door]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.staircase),
        expression: "realestate.staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.staircase)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.staircase = $event.target.value
        }, _vm.set_realestate_staircase]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Block')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.block),
        expression: "realestate.block"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.block)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.block = $event.target.value
        }, _vm.set_realestate_block]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Height_situation')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.floor_number),
        expression: "realestate.floor_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.floor_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.floor_number = $event.target.value
        }, _vm.set_realestate_floor_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floor_typeValue,
        "options": _vm.floor_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_floor_type
      },
      model: {
        value: (_vm.realestate.floor_type),
        callback: function($$v) {
          _vm.realestate.floor_type = $$v
        },
        expression: "realestate.floor_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('span', {
      staticClass: "help"
    }, [_c('i', [_vm._v(_vm._s(_vm.$t('Full_address')) + ":")]), _vm._v(" " + _vm._s(_vm.realestate.full_address))])])])])]) : _vm._e()]), _vm._v(" "), (this.realestate.municipality && this.realestate.street_name && this.realestate.street_number) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Geolocation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGeolocate($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onGeolocate($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Geolocate')))], 1)])]), _vm._v(" "), (_vm.google_geocode_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Latitude')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.lat),
        expression: "realestate.lat"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.lat)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.lat = $event.target.value
        }, _vm.set_realestate_lat],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Longitude')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.lng),
        expression: "realestate.lng"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.lng)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.lng = $event.target.value
        }, _vm.set_realestate_lng],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Postal_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.postal_code),
        expression: "realestate.postal_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.postal_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.postal_code = $event.target.value
        }, _vm.set_realestate_postal_code]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("X EPSG:25831")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.epsg25831_x),
        expression: "realestate.epsg25831_x"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.epsg25831_x)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.epsg25831_x = $event.target.value
        }, _vm.set_realestate_epsg25831_x],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Y EPSG:25831")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.epsg25831_y),
        expression: "realestate.epsg25831_y"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.epsg25831_y)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.epsg25831_y = $event.target.value
        }, _vm.set_realestate_epsg25831_y],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('span', {
      staticClass: "help"
    }, [_c('i', [_vm._v("Aquesta geolocalització es correspon a l'adreça:")]), _vm._v(" " + _vm._s(_vm.realestate.google_formatted_address) + ", (" + _vm._s(_vm.realestate.geohash) + ")")])])])]) : _vm._e(), _vm._v(" "), (this.realestate.epsg25831_x && this.realestate.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Census_section')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCensusSectionInfo($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCensusSectionInfo($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Census_section')))], 1)])]), _vm._v(" "), (_vm.icc_census_section_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Census_section_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.census_section_code),
        expression: "realestate.census_section_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.census_section_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.census_section_code = $event.target.value
        }, _vm.set_realestate_census_section_code]
      }
    })])])]) : _vm._e(), _vm._v(" "), (this.realestate.epsg25831_x && this.realestate.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCadastralReferenceSuggestion($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCadastralReferenceSuggestion($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Cadastral_reference')))], 1)])]), _vm._v(" "), (_vm.cadaster_ref_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.cadastral_reference),
        expression: "realestate.cadastral_reference"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "maxlength": "20",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.cadastral_reference)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.cadastral_reference = $event.target.value
        }, _vm.set_realestate_cadastral_reference]
      }
    })]), _vm._v(" "), (_vm.realestate.cadastral_reference) ? _c('div', [(_vm.realestate.cadastral_reference.length > 0 && _vm.realestate.cadastral_reference.length < 20) ? _c('message', {
      attrs: {
        "text": _vm.cad_ref_error_text_01,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralMap($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralMap($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_Map')))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })]) : _vm._e(), _vm._v(" "), (this.realestate.lat && this.realestate.lng) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Maps')))]), _vm._v(" "), (_vm.google_map_01_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 01...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.google_map_02_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 02...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.google_map_03_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 03...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "justify-content": "baseline!important"
      }
    }, [(_vm.realestate.map_google_01_url) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 1/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.realestate.map_google_01_url,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("center: " + _vm._s(_vm.realestate.map_google_01_lat) + ", " + _vm._s(_vm.realestate.map_google_01_lng))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.realestate.map_google_01_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.realestate.map_google_02_url) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 2/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.realestate.map_google_02_url,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("center: " + _vm._s(_vm.realestate.map_google_02_lat) + ", " + _vm._s(_vm.realestate.map_google_02_lng))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.realestate.map_google_02_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.realestate.map_google_03_url) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 3/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.realestate.map_google_03_url,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("center: " + _vm._s(_vm.realestate.map_google_03_lat) + ", " + _vm._s(_vm.realestate.map_google_03_lng))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.realestate.map_google_03_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.realestate.lat && this.realestate.lng) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Area_prices')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [
      [_c('gmap-map', {
        staticStyle: {
          "width": "100vw",
          "height": "40vw"
        },
        attrs: {
          "center": {
            lat: this.realestate.lat,
            lng: this.realestate.lng
          },
          "zoom": 16,
          "options": {
            styles: _vm.mapStyles,
            scrollwheel: false
          }
        }
      }, [_vm._l((this.realestate.area_ads_markers), function(m, index) {
        return _c('gmap-marker', {
          key: index,
          attrs: {
            "position": m.position,
            "clickable": true,
            "draggable": false,
            "opacity": m.opacity,
            "title": m.title,
            "label": m.label,
            "icon": m.icon
          },
          on: {
            "click": function($event) {
              _vm.openAdUrl(m.url)
            }
          }
        })
      }), _vm._v(" "), _c('gmap-marker', {
        key: 9999,
        attrs: {
          "position": {
            lat: this.realestate.lat,
            lng: this.realestate.lng
          },
          "clickable": false,
          "draggable": false
        }
      })], 2)]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Area_average_unit_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.area_average_price)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Max_distance')) + " (Km.)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.area_ads_query_distance),
        expression: "realestate.area_ads_query_distance"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false",
        "min": "0.1",
        "step": "0.1",
        "max": "60"
      },
      domProps: {
        "value": (_vm.realestate.area_ads_query_distance)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.area_ads_query_distance = $event.target.value
        }, _vm.set_realestate_area_ads_query_distance],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ads_date_range')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(this.prices_startdate_readformat) + " - " + _vm._s(this.prices_limitdate_readformat))])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCheckPrices($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onCheckPrices($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Check_prices')))], 1)])]), _vm._v(" "), (_vm.check_prices_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e()]), _vm._v(" "), (this.realestate.area_ads_markers) ? _c('div', {
      staticClass: "field-container"
    }, [_c('span', [_vm._v("* Nota: La següent és una selecció automàtica dels anuncis més propers a l'immoble extistents a la base de dades de BARNA-TASA, S.A.")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('th', {
      staticStyle: {
        "width": "60px",
        "text-align": "center"
      }
    }, [_vm._v("#")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "160px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.$t('Actions')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "320px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Offer_unit_price')))])]), _vm._v(" "), _vm._l((this.realestate.area_ads_markers), function(m, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('table', {
        staticStyle: {
          "border": "none"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "border": "none",
          "padding": "0.1rem"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.openAdUrl(m.url)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "link",
          "scale": ".9",
          "color": "gray"
        }
      })], 1)]), _vm._v(" "), _c('td', {
        staticStyle: {
          "border": "none",
          "padding": "0.1rem"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.discardAd(index)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "times",
          "scale": ".9",
          "color": "gray"
        }
      })], 1)])])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.address))]), _vm._v(" "), _c('td', {
        style: (_vm.backgroundStyle(m.step))
      }, [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(m.unit_price)) + " €/m²")])])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (this.realestate.lat && this.realestate.lng) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Pre_appraisal')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Area_average_unit_price')) + " (€/m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.area_average_price),
        expression: "realestate.area_average_price"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.area_average_price)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.area_average_price = $event.target.value
        }, _vm.set_realestate_area_average_price],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Area_average_price_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.area_average_price_coef),
        expression: "realestate.area_average_price_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false",
        "step": "0.01"
      },
      domProps: {
        "value": (_vm.realestate.area_average_price_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.area_average_price_coef = $event.target.value
        }, _vm.set_realestate_area_average_price_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_area_average_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.adopted_area_average_price)) + " €/m²")])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Estimated_built_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.estimated_built_area),
        expression: "realestate.estimated_built_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.estimated_built_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.estimated_built_area = $event.target.value
        }, _vm.set_realestate_estimated_built_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Pre_appraisal_value')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.pre_appraisal_value)) + " €")])])]), _vm._v(" "), (!this.realestate.estimated_built_area) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta indicar la superfície estimada",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.appraisal_cost_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Pressupost')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.quote_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Quote')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.quote_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Presupuesto')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.quote_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Travel_expenses')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Travel_one_way_hours')) + " (h)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.travel_one_way_hours),
        expression: "realestate.travel_one_way_hours"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.travel_one_way_hours)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.travel_one_way_hours = $event.target.value
        }, _vm.set_realestate_travel_one_way_hours],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Travel_both_ways_hours')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.travel_both_ways_hours) + " h")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Travel_fees_per_hour')) + " (€/h)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.travel_fees_per_hour),
        expression: "realestate.travel_fees_per_hour"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.travel_fees_per_hour)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.travel_fees_per_hour = $event.target.value
        }, _vm.set_realestate_travel_fees_per_hour],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_fuel_expenses_one_way')) + " (€)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.car_fuel_expenses_one_way),
        expression: "realestate.car_fuel_expenses_one_way"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.car_fuel_expenses_one_way)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.car_fuel_expenses_one_way = $event.target.value
        }, _vm.set_realestate_car_fuel_expenses_one_way],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_fuel_expenses_both_ways')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.car_fuel_expenses_both_ways) + " €")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_toll_expenses_one_way')) + " (€)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.car_toll_expenses_one_way),
        expression: "realestate.car_toll_expenses_one_way"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.car_toll_expenses_one_way)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.car_toll_expenses_one_way = $event.target.value
        }, _vm.set_realestate_car_toll_expenses_one_way],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_toll_expenses_both_ways')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.car_toll_expenses_both_ways) + " €")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Total_travel_fees')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.realestate.total_travel_fees) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_fees')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Acc_eco_decree_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_appraisal_type_is_eco),
        expression: "realestate.quote_appraisal_type_is_eco"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.realestate.quote_appraisal_type_is_eco) ? _vm._i(_vm.realestate.quote_appraisal_type_is_eco, null) > -1 : (_vm.realestate.quote_appraisal_type_is_eco)
      },
      on: {
        "click": _vm.set_realestate_quote_appraisal_type_is_eco,
        "__c": function($event) {
          var $$a = _vm.realestate.quote_appraisal_type_is_eco,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.realestate.quote_appraisal_type_is_eco = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.realestate.quote_appraisal_type_is_eco = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.realestate.quote_appraisal_type_is_eco = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Pre_appraisal_value')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.pre_appraisal_value)) + " €")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_base_fees')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_base_fees),
        expression: "realestate.quote_base_fees"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.quote_base_fees)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.quote_base_fees = $event.target.value
        }, _vm.set_realestate_quote_base_fees],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_excess_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_excess_pct),
        expression: "realestate.quote_excess_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.quote_excess_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.quote_excess_pct = $event.target.value
        }, _vm.set_realestate_quote_excess_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_base_price_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_base_price_coef),
        expression: "realestate.quote_base_price_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.quote_base_price_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.quote_base_price_coef = $event.target.value
        }, _vm.set_realestate_quote_base_price_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_base_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.realestate.quote_base_price) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Valuation_pricing_info_table')))]), _vm._v(" "), (_vm.realestate.property_type) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', [(_vm.realestate.property_type.name_db === 'residential' || _vm.realestate.property_type.name_db === 'parking' || _vm.realestate.property_type.name_db === 'storage') ? _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v(_vm._s(_vm.$t('Dwellings')) + ", " + _vm._s(_vm.$t('Parking_spaces')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Storerooms')))]), _vm._v(" "), _c('table', {
      staticClass: "d-table-center"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_A), function(range, key, index) {
      return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)])]) : (_vm.realestate.property_type.name_db === 'retail_and_industrial' || _vm.realestate.property_type.name_db === 'office') ? _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v(_vm._s(_vm.$t('Commercial_premises')) + ", " + _vm._s(_vm.$t('Offices')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Industrial_warehouses')))]), _vm._v(" "), _c('table', {
      staticClass: "d-table-center"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_B), function(range, key, index) {
      return (index < 5) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)])]) : (_vm.realestate.property_type.name_db === 'entire_buildings' || _vm.realestate.property_type.name_db === 'land') ? _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Buildings')) + ", " + _vm._s(_vm.$t('Property_developments')) + ", " + _vm._s(_vm.$t('Properties_under_economic_exploitation')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Land_pl')))]), _vm._v(" "), _c('table', {
      staticClass: "d-table-center"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Fees')) + " *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_C), function(range, key, index) {
      return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)])]) : _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v(_vm._s(_vm.$t('Machinery')) + ", " + _vm._s(_vm.$t('Expropriations')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('others')) + ": "), _c('span', {
      staticStyle: {
        "color": "gray"
      }
    }, [_vm._v(_vm._s(_vm.$t('acc_Budget')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup'), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_03')) + ".\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("1")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_04')) + ".\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("2")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_05')) + ".\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br')])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.marketstudies_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Estudis de mercat')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.marketstudies_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Market studies')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.marketstudies_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Estudios de mercado')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.marketstudies_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_studies_for_this_real_estate')))]), _vm._v(" "), (_vm.object_length(_vm.realestate_marketstudies) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy_table.filter),
        expression: "marketstudy_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.marketstudy_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.realestate_marketstudies),
        "page-size": 10,
        "filter": _vm.marketstudy_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-marketstudy",
              "source": page.data,
              "filterable": false,
              "striped": _vm.marketstudy_table.striped,
              "editable": _vm.marketstudy_table.editable,
              "line-numbers": _vm.marketstudy_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-marketstudy",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', {
                  staticClass: "actions_td"
                }, [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editMarketStudy(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.marketstudy_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-marketstudy",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.appraisals_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Taxacions')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.appraisals_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Appraisals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.appraisals_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Tasaciones')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.appraisals_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisals_of_the_Real_Estate')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAppraisal($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisal_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.realestate_appraisals) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal_table.filter),
        expression: "appraisal_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.appraisal_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.realestate_appraisals),
        "page-size": 10,
        "filter": _vm.appraisal_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-appraisal",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisal_table.striped,
              "editable": _vm.appraisal_table.editable,
              "line-numbers": _vm.appraisal_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-appraisal",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraisal(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateAppraisal(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisal(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.appraisal_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-appraisal",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.projects_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Projectes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.projects_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Projects')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.projects_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Proyectos')
        }
      },
      slot: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.projects_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Projects_of_the_Real_Estate')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewProject($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_project_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.realestate_projects) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.project_table.filter),
        expression: "project_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.project_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.project_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.realestate_projects),
        "page-size": 10,
        "filter": _vm.project_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-project",
              "source": page.data,
              "filterable": false,
              "striped": _vm.project_table.striped,
              "editable": _vm.project_table.editable,
              "line-numbers": _vm.project_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-project",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editProject(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateProject(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteProject(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.project_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-project",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Versió')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Version')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Versión')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('RealEstate_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.description),
        expression: "realestate.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.description = $event.target.value
        }, _vm.set_realestate_description]
      }
    })])])])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentRealEstate({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentRealEstate({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.realestate.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e5a3bc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/realestates/RealEstateEditor.vue
// module id = 2145
// module chunks = 0